import { useIsClient } from '@crehana/react-hooks';
import { Skeleton } from '@crehana/ui/dist/Skeleton';
// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

import SocialButtons from '@/shared/components/AuthForm/components/SocialButtons';

const StyledSocialButtons = styled.div`
  & div {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  & button {
    padding: 0;
    width: 54px;
    height: 54px;
    border-radius: 50%;
    border: none !important;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  & span {
    display: none;
  }

  & button:nth-child(1) {
    background-color: #1877f2 !important;
    margin-right: 40px;
  }

  & button:nth-child(2) {
    color: #181b32;
    & div {
      margin: 0;
    }
  }
`;

const SocialAuth = () => {
  const isClient = useIsClient();

  if (isClient) {
    return (
      <StyledSocialButtons>
        <SocialButtons />
      </StyledSocialButtons>
    );
  }

  return (
    <>
      <Skeleton isDark className="w-full h-56 mb-16" />
      <Skeleton isDark className="w-full h-56" />
    </>
  );
};

export default SocialAuth;
